import useEventFormModulesBuilder from './useEventFormModulesBuilder'
import { withTranslationCustom } from 'lib/i18next'

const EventFormModules = ({ wrappedEvent, form, t }) => {
    const builder = useEventFormModulesBuilder({ wrappedEvent, form, t })
    const schema = wrappedEvent.getModulesLayoutSchema()
    return builder.renderModulesWithLayout(schema, builder.modules)
}

export default withTranslationCustom(['events'])(EventFormModules)
